import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useSubscriptionItem} from '../hooks/useSubscriptionItem';
import {SubscriptionItem} from '../types';
import {useParams} from 'react-router-dom';

export const AddFormDrawer = (props: DrawerProps) => {

    const {id: customerId} = useParams();

    if (typeof customerId === 'undefined') {
        throw new Error('customerId is required parameter');
    }

    const {createRecord} = useSubscriptionItem(customerId);

    return (
        <FormDrawer
            record={{
                id: '',
                price: '',
                subscription: '',
            } as SubscriptionItem}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
